// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"SliderOfferSection_cardContainer__1vhiW","sliderContainer":"SliderOfferSection_sliderContainer__3-K1K","nextButton":"SliderOfferSection_nextButton__305C4"};